import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { ViewService } from '../service/view/view.service';
import { EMPTY, map } from 'rxjs';
import { ViewQuery } from '../model';

@Injectable({ providedIn: 'root' })
export class ViewResolver implements Resolve<any> {
    constructor(
        private readonly router: Router,
        private readonly viewService: ViewService
    ) { }

    public resolve(route: ActivatedRouteSnapshot) {
        // FULL path segments (supports deep CMS paths)
        const segments = route.url.map(x => x.path);
        const queryParams = { ...route.queryParams };

        if (!segments.length) {
            this.router.navigate(['index'], { queryParams });
            return EMPTY;
        }

        const viewQuery = new ViewQuery(queryParams, segments);

        // Fetch CMS view on server
        return this.viewService.getView(viewQuery.name).pipe(
            map(dynamic => ({
                dynamic,
                query: viewQuery
            }))
        );
    }
}
